import moment from 'moment'
import React, { useState } from 'react'
import DatePicker from 'react-date-picker'
import { CalendarInputProps } from './CalendarInput.props'
import {
  CalendarInputContainer,
  CalendarInputLabel,
  CalendarInputSpan,
} from './CalendatInput.styled'

const CalendarInput = ({
  onDateSelected,
  label,
  required,
  value
}: CalendarInputProps) => {
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false)
  return (
    <CalendarInputContainer onClick={() => setShowDatePicker(!showDatePicker)}>
      {label && (
        <CalendarInputLabel>
          {label} {required && <CalendarInputSpan>*</CalendarInputSpan>}
        </CalendarInputLabel>
      )}
      {value && moment(value).format('MM/DD/yyyy')}
      <DatePicker
        isOpen={showDatePicker}
        onChange={onDateSelected}
        value={value}
        clearIcon={null}
        calendarIcon={null}
      />
    </CalendarInputContainer>
  )
}

export default CalendarInput
